module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "live-run__content liveRaceContent"
  }, [_c('race-header', {
    attrs: {
      "isPastRun": this.$props.pastRun
    }
  }), _vm._v(" "), _c('runners-table'), _vm._v(" "), (this.$route.query.openhood == 1) ? _c('edit-runner') : _vm._e(), _vm._v(" "), (_vm.showDebugOptions) ? _c('debug-options') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1683536a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race.vue
// module id = 1640
// module chunks = 1